import { useEffect, useMemo, useState } from 'react';
import { serviceOptions } from '../../../functions/serviceOptions';
export const useGetChannelClaim = ({ warrantyData, watch }) => {
  const [storeNameOptions, setStoreNameOptions] = useState([]);
  const channelClaimOptions = useMemo(
    () => serviceOptions('CHANNEL_CLAIM', warrantyData?.warranty?.channelClaims),
    [warrantyData],
  );

  const channelClaimId = watch('channelClaimId');

  useEffect(() => {
    const selectedChannelClaim = channelClaimOptions?.find((el) => el?.value === channelClaimId);

    if (
      selectedChannelClaim &&
      (selectedChannelClaim?.channelClaimCode === 'STORE' ||
        selectedChannelClaim?.channelClaimCode === 'FOCUS')
    ) {
      setStoreNameOptions(serviceOptions('STORE_NAME', warrantyData?.warranty?.stores));
    } else {
      setStoreNameOptions([]);
    }
  }, [channelClaimId, channelClaimOptions]);

  return {
    channelClaimOptions,
    storeNameOptions,
  };
};
